import React from 'react';
import PlanSelector from '../forms/personal/PlanSelector';
// Listado de planes con opcion de seleccion multiple
// Los planes pueden ser estandares, especificos, ambos
const PlanListMultiple = ({
  planes,
  onChange,
  tituloAdicional,
  moneda,
  opcionesDePago,
  selectedIndexs,
  mostrarLandingPorDefecto,
  landingPorDefectoIndex,
  landingPorDefectoAuxIndex
}) => {
  return (
    <>
      {planes?.length > 0 && moneda ? (
        <PlanSelector
          selected={selectedIndexs}
          onChange={onChange}
          planes={planes}
          hover
          multiple
          mostrarTipo
          tituloAdicional={tituloAdicional}
          opcionesDePago={opcionesDePago}
          moneda={moneda}
          mostrarLandingPorDefecto={mostrarLandingPorDefecto}
          landingPorDefectoIndex={landingPorDefectoIndex}
          landingPorDefectoAuxIndex={landingPorDefectoAuxIndex}
        />
      ) : (
        <p style={{ fontSize: '20px', fontWeight: 'bold' }}>{`Sin ${
          tituloAdicional || 'Detalle de Cobertura'
        }`}</p>
      )}
    </>
  );
};

export default PlanListMultiple;
